<ng-container *ngIf="vo$ | async; let vo">
	<mat-accordion [multi]="false">
		<mat-expansion-panel
			[expanded]="vo.currentStep === ProfileConfigStep.ProfileMetadata"
			(opened)="setStep(ProfileConfigStep.ProfileMetadata)">
			<mat-expansion-panel-header
				[ngClass]="vo.errors.get(SubscriptionErrorKey.ProfileMissingFields)
						? 'invalid-step'
						: 'valid-step'">
				<mat-panel-title>
					<span
						i18n="@@subscription.profile.config.profileMetadataStep.title">
						profile-title</span>
				</mat-panel-title>
				<mat-panel-description>
					<span
						i18n="@@subscription.profile.config.profileMetadataStep.description">
						profile-description</span>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<div class="profile-metadata">
				<ng-container
					[ngTemplateOutlet]="profileMetadata"></ng-container>
			</div>

			<mat-action-row>
				<button
					mat-flat-button
					color="primary"
					(click)="nextStep(ProfileConfigStep.ProfileMetadata)">
					<span
						i18n="@@general.stepper.next">
						next</span>
				</button>
			</mat-action-row>
		</mat-expansion-panel>

		<mat-expansion-panel
			[expanded]="vo.currentStep === ProfileConfigStep.ColumnModel"
			(opened)="setStep(ProfileConfigStep.ColumnModel)">
			<mat-expansion-panel-header
				[ngClass]="vo.errors.get(SubscriptionErrorKey.NoSelectColumnModel)
						? 'invalid-step'
						: 'valid-step'">
				<mat-panel-title>
					<span
						i18n="@@subscription.profile.config.columnModelStep.title">
						column-model-title</span>
				</mat-panel-title>
				<mat-panel-description>
					<span
						i18n="@@subscription.profile.config.columnModelStep.description">
						column-model-description</span>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<div class="column-models">
					<app-column-models
						[columnModels]="vo.columnModels"
						[mode]="vo.mode === 'STEPPER' ?  'PROFILE_STEPPER' : 'PROFILE_STANDALONE'"
						[canRefresh]="vo.mode !== 'STEPPER'"
						[selectedId]="vo.profileConfig.columnModelId"
						[availableColumns]="vo.availableColumns"
						(reloadColumnModels)="refreshColumnModels()"></app-column-models>
			</div>

			<mat-action-row>
				<button
					mat-stroked-button
					color="accent"
					(click)="previousStep(ProfileConfigStep.ColumnModel)">
					<span
						i18n="@@general.stepper.back">
						back</span>
				</button>
				<button
					mat-flat-button
					color="primary"
					(click)="nextStep(ProfileConfigStep.ColumnModel)">
					<span
						i18n="@@general.stepper.next">
						next</span>
				</button>
			</mat-action-row>
		</mat-expansion-panel>

		<mat-expansion-panel
			[expanded]="vo.currentStep === ProfileConfigStep.FilterModel"
			(opened)="setStep(ProfileConfigStep.FilterModel)">
			<mat-expansion-panel-header
				[ngClass]="vo.errors.get(SubscriptionErrorKey.NoSelectFilterModel)
						? 'optional-step'
						: 'valid-step'">

				<mat-panel-title>
					<span
						i18n="@@subscription.profile.config.filterModelStep.title">
						filter-model-title</span>
				</mat-panel-title>
				<mat-panel-description>
					<span
						i18n="@@subscription.profile.config.filterModelStep.description">
						filter-model-description</span>
				</mat-panel-description>
			</mat-expansion-panel-header>

			<div class="filter-models">
					<app-filter-models
						[mode]="vo.mode === 'STEPPER' || vo.mode === 'STANDALONE' ? 'PROFILE' : 'STANDALONE'"
						[canRefresh]="vo.mode !== 'STEPPER'"
						[availableColumns]="vo.availableColumns"
						[filterModels]="vo.filterModels"
						[selectedIds]="vo.profileConfig.filterModelIds"
						(reloadFilterModels)="refreshFilterModels()"></app-filter-models>
			</div>

			<mat-action-row>
				<button
					mat-stroked-button
					color="accent"
					(click)="previousStep(ProfileConfigStep.FilterModel)">
					<span
						i18n="@@general.stepper.back">
						back</span>
				</button>
				<!--<button
					mat-button
					color="primary">
					End</button>-->
			</mat-action-row>
		</mat-expansion-panel>
	</mat-accordion>
</ng-container>

<ng-template #profileMetadata>
	<app-card-outline class="profile-metadata-card">
		<span card-outline-title i18n="@@subscription.profile.config.metadata.title">profile-metadata</span>
		<form
			card-outline-content
			class="profile-metadata-card__content"
			[formGroup]="profileConfigForm.form">
			<mat-form-field [appearance]="Appearance">
				<mat-label
					i18n="@@subscription.profile.config.metadata.form.label">
					label</mat-label>
				<input
					type="text"
					id="{{ cmpId + '-label-input' }}"
					matInput
					[formControlName]="ProfileConfigFormControls.Label" />

				<mat-hint [align]="'end'">
					{{profileConfigForm.form
					.get(ProfileConfigFormControls.Label)?.value?.length || 0 }}/{{Configuration.maxLengthLabel}}</mat-hint>

				<mat-error
					*ngIf="profileConfigForm.form
						.get(ProfileConfigFormControls.Label)
						?.hasError(ValidationErrorKeys.Maxlength)"
					i18n="@@general.form.errors.maxlength">
					max length</mat-error>
				<mat-error
					*ngIf="profileConfigForm.form
						.get(ProfileConfigFormControls.Label)
						?.hasError(ValidationErrorKeys.Required)"
					i18n="@@general.form.errors.required">
					max length</mat-error>
			</mat-form-field>

			<mat-form-field [appearance]="Appearance">
				<mat-label
					i18n="@@subscription.profile.config.metadata.form.description">
					description</mat-label>
				<textarea
					type="text"
					[rows]="4"
					id="{{ cmpId + '-description-input' }}"
					matInput
					[formControlName]="ProfileConfigFormControls.Description"></textarea>

				<mat-hint [align]="'end'">
					{{profileConfigForm.form
					.get(ProfileConfigFormControls.Description)?.value?.length || 0 }}/{{Configuration.maxLengthDescription}}</mat-hint>

				<mat-error
					*ngIf="profileConfigForm.form
						.get(ProfileConfigFormControls.Description)
						?.hasError(ValidationErrorKeys.Maxlength)"
					i18n="@@general.form.errors.maxlength">
					max length</mat-error>
			</mat-form-field>
		</form>
	</app-card-outline>
</ng-template>
